import React from 'react';
export default function Shop() {
    return(
        <main className='pageContent'>
            <h2>
                Shop
            </h2>
        </main>
    );
    }